import { render } from "./SimpleDialogMessage.vue?vue&type=template&id=6f042a7a&scoped=true"
import script from "./SimpleDialogMessage.vue?vue&type=script&lang=js"
export * from "./SimpleDialogMessage.vue?vue&type=script&lang=js"

import "./SimpleDialogMessage.vue?vue&type=style&index=0&id=6f042a7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f042a7a"]])

export default __exports__